(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'androidx-navigationevent-navigationevent'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'androidx-navigationevent-navigationevent'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'androidx-navigationevent-navigationevent'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'androidx-navigationevent-navigationevent'.");
    }
    globalThis['androidx-navigationevent-navigationevent'] = factory(typeof globalThis['androidx-navigationevent-navigationevent'] === 'undefined' ? {} : globalThis['androidx-navigationevent-navigationevent'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var protoOf = kotlin_kotlin.$_$.eh;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var VOID = kotlin_kotlin.$_$.d;
  var emptyList = kotlin_kotlin.$_$.c9;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.o6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var addAll = kotlin_kotlin.$_$.o7;
  var get_indices = kotlin_kotlin.$_$.z9;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var equals = kotlin_kotlin.$_$.sf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var MutableStateFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s1;
  var asStateFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v1;
  var ArrayDeque_init_$Create$ = kotlin_kotlin.$_$.x3;
  var Collection = kotlin_kotlin.$_$.y6;
  var isInterface = kotlin_kotlin.$_$.rg;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(NavigationEvent, 'NavigationEvent');
  initMetadataForCompanion(Companion);
  initMetadataForClass(NavigationEventDispatcher, 'NavigationEventDispatcher', NavigationEventDispatcher_init_$Create$);
  initMetadataForClass(NavigationEventHandler, 'NavigationEventHandler');
  initMetadataForClass(NavigationEventHistory, 'NavigationEventHistory');
  initMetadataForClass(NavigationEventInfo, 'NavigationEventInfo');
  initMetadataForClass(NavigationEventInput, 'NavigationEventInput');
  initMetadataForClass(NavigationEventProcessor, 'NavigationEventProcessor', NavigationEventProcessor);
  initMetadataForClass(NavigationEventTransitionState, 'NavigationEventTransitionState');
  initMetadataForObject(Idle, 'Idle', VOID, NavigationEventTransitionState);
  initMetadataForClass(InProgress, 'InProgress', VOID, NavigationEventTransitionState);
  initMetadataForCompanion(Companion_0);
  //endregion
  function NavigationEvent() {
  }
  protoOf(NavigationEvent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NavigationEvent))
      THROW_CCE();
    if (!(this.r8m_1 === other.r8m_1))
      return false;
    if (!(this.s8m_1 === other.s8m_1))
      return false;
    if (!(this.q8m_1 === other.q8m_1))
      return false;
    if (!(this.p8m_1 === other.p8m_1))
      return false;
    if (!equalsLong(this.t8m_1, other.t8m_1))
      return false;
    return true;
  };
  protoOf(NavigationEvent).hashCode = function () {
    var result = getNumberHashCode(this.r8m_1);
    result = imul(31, result) + getNumberHashCode(this.s8m_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.q8m_1) | 0;
    result = imul(31, result) + this.p8m_1 | 0;
    result = imul(31, result) + this.t8m_1.hashCode() | 0;
    return result;
  };
  protoOf(NavigationEvent).toString = function () {
    return 'NavigationEvent(touchX=' + this.r8m_1 + ', touchY=' + this.s8m_1 + ', progress=' + this.q8m_1 + ', ' + ('swipeEdge=' + this.p8m_1 + ', frameTimeMillis=' + this.t8m_1.toString() + ')');
  };
  function NavigationEventDispatcher_init_$Init$($this) {
    NavigationEventDispatcher.call($this, null, null);
    return $this;
  }
  function NavigationEventDispatcher_init_$Create$() {
    return NavigationEventDispatcher_init_$Init$(objectCreate(protoOf(NavigationEventDispatcher)));
  }
  function _get_isDisposed__7k3404($this) {
    var tmp;
    var tmp0_safe_receiver = $this.u8m_1;
    if ((tmp0_safe_receiver == null ? null : _get_isDisposed__7k3404(tmp0_safe_receiver)) === true) {
      tmp = true;
    } else {
      tmp = $this.w8m_1;
    }
    return tmp;
  }
  function checkInvariants($this) {
    // Inline function 'kotlin.check' call
    if (!!_get_isDisposed__7k3404($this)) {
      var message = 'This NavigationEventDispatcher has already been disposed and cannot be used.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function Companion() {
    this.c8n_1 = 0;
    this.d8n_1 = 1;
  }
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function NavigationEventDispatcher(parent, onBackCompletedFallback) {
    this.u8m_1 = parent;
    this.v8m_1 = onBackCompletedFallback;
    this.w8m_1 = false;
    this.x8m_1 = true;
    var tmp = this;
    var tmp0_safe_receiver = this.u8m_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y8m_1;
    tmp.y8m_1 = tmp1_elvis_lhs == null ? new NavigationEventProcessor() : tmp1_elvis_lhs;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_0.z8m_1 = LinkedHashSet_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_1.a8n_1 = LinkedHashSet_init_$Create$();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_2.b8n_1 = LinkedHashSet_init_$Create$();
    var tmp0_safe_receiver_0 = this.u8m_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.collections.plusAssign' call
      tmp0_safe_receiver_0.z8m_1.j1(this);
    }
  }
  protoOf(NavigationEventDispatcher).e8n = function () {
    var tmp;
    var tmp0_safe_receiver = this.u8m_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e8n()) === false) {
      tmp = false;
    } else {
      tmp = this.x8m_1;
    }
    return tmp;
  };
  protoOf(NavigationEventDispatcher).f8n = function (handler, priority) {
    checkInvariants(this);
    if (this.a8n_1.j1(handler)) {
      this.y8m_1.v8n(this, handler, priority);
    }
  };
  protoOf(NavigationEventDispatcher).w8n = function (handler, priority, $super) {
    priority = priority === VOID ? 1 : priority;
    var tmp;
    if ($super === VOID) {
      this.f8n(handler, priority);
      tmp = Unit_instance;
    } else {
      tmp = $super.f8n.call(this, handler, priority);
    }
    return tmp;
  };
  protoOf(NavigationEventDispatcher).x8n = function (handler) {
    if (this.a8n_1.d3(handler)) {
      this.y8m_1.y8n(handler);
    }
  };
  protoOf(NavigationEventDispatcher).z8n = function (input) {
    checkInvariants(this);
    if (this.b8n_1.j1(input)) {
      this.y8m_1.a8o(this, input, -1);
    }
  };
  protoOf(NavigationEventDispatcher).b8o = function (input, direction, event) {
    checkInvariants(this);
    if (!this.e8n())
      return Unit_instance;
    this.y8m_1.c8o(input, direction, event);
  };
  protoOf(NavigationEventDispatcher).d8o = function (input, direction) {
    checkInvariants(this);
    if (!this.e8n())
      return Unit_instance;
    this.y8m_1.e8o(input, direction, this.v8m_1);
  };
  function NavigationEventHandler_init_$Init$(initialInfo, isBackEnabled, $this) {
    NavigationEventHandler.call($this, initialInfo, isBackEnabled, false);
    return $this;
  }
  function NavigationEventHandler(initialInfo, isBackEnabled, isForwardEnabled) {
    this.f8o_1 = initialInfo;
    this.g8o_1 = emptyList();
    this.h8o_1 = emptyList();
    this.i8o_1 = Idle_getInstance();
    this.j8o_1 = isBackEnabled;
    this.k8o_1 = isForwardEnabled;
    this.l8o_1 = null;
  }
  protoOf(NavigationEventHandler).m8o = function (value) {
    if (this.j8o_1 === value)
      return Unit_instance;
    this.j8o_1 = value;
    var tmp0_safe_receiver = this.l8o_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y8m_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.n8o();
    }
  };
  protoOf(NavigationEventHandler).o8o = function () {
    var tmp;
    var tmp0_safe_receiver = this.l8o_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e8n()) === false) {
      tmp = false;
    } else {
      tmp = this.j8o_1;
    }
    return tmp;
  };
  protoOf(NavigationEventHandler).p8o = function (value) {
    if (this.k8o_1 === value)
      return Unit_instance;
    this.k8o_1 = value;
    var tmp0_safe_receiver = this.l8o_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y8m_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.n8o();
    }
  };
  protoOf(NavigationEventHandler).q8o = function () {
    var tmp;
    var tmp0_safe_receiver = this.l8o_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e8n()) === false) {
      tmp = false;
    } else {
      tmp = this.k8o_1;
    }
    return tmp;
  };
  protoOf(NavigationEventHandler).l4 = function () {
    var tmp0_safe_receiver = this.l8o_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.x8n(this);
    }
  };
  protoOf(NavigationEventHandler).r8o = function (currentInfo, backInfo, forwardInfo) {
    this.f8o_1 = currentInfo;
    this.g8o_1 = backInfo;
    this.h8o_1 = forwardInfo;
    var tmp0_safe_receiver = this.l8o_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y8m_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.s8o(this);
    }
  };
  protoOf(NavigationEventHandler).t8o = function (event) {
    this.i8o_1 = new InProgress(event, -1);
    this.u8o(event);
  };
  protoOf(NavigationEventHandler).u8o = function (event) {
  };
  protoOf(NavigationEventHandler).v8o = function () {
    this.i8o_1 = Idle_getInstance();
    this.w8o();
  };
  protoOf(NavigationEventHandler).w8o = function () {
    throw UnsupportedOperationException_init_$Create$("A handler that receives a 'backCompleted' event must override 'onBackCompleted()' to handle the callback.");
  };
  protoOf(NavigationEventHandler).x8o = function () {
    this.i8o_1 = Idle_getInstance();
    this.y8o();
  };
  protoOf(NavigationEventHandler).y8o = function () {
  };
  protoOf(NavigationEventHandler).z8o = function (event) {
    this.i8o_1 = new InProgress(event, 1);
    this.a8p(event);
  };
  protoOf(NavigationEventHandler).a8p = function (event) {
  };
  protoOf(NavigationEventHandler).b8p = function () {
    this.i8o_1 = Idle_getInstance();
    this.c8p();
  };
  protoOf(NavigationEventHandler).c8p = function () {
    throw UnsupportedOperationException_init_$Create$("A handler that receives a 'forwardCompleted' event must override 'onForwardCompleted()' to handle the callback.");
  };
  protoOf(NavigationEventHandler).d8p = function () {
    this.i8o_1 = Idle_getInstance();
    this.e8p();
  };
  protoOf(NavigationEventHandler).e8p = function () {
  };
  function NavigationEventHistory_init_$Init$($this) {
    NavigationEventHistory.call($this, emptyList(), -1);
    return $this;
  }
  function NavigationEventHistory_init_$Create$() {
    return NavigationEventHistory_init_$Init$(objectCreate(protoOf(NavigationEventHistory)));
  }
  function NavigationEventHistory_init_$Init$_0(currentInfo, backInfo, forwardInfo, $this) {
    backInfo = backInfo === VOID ? emptyList() : backInfo;
    forwardInfo = forwardInfo === VOID ? emptyList() : forwardInfo;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.plusAssign' call
    addAll(this_0, backInfo);
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.j1(currentInfo);
    // Inline function 'kotlin.collections.plusAssign' call
    addAll(this_0, forwardInfo);
    var tmp$ret$0 = this_0.t5();
    NavigationEventHistory.call($this, tmp$ret$0, backInfo.n1());
    return $this;
  }
  function NavigationEventHistory_init_$Create$_0(currentInfo, backInfo, forwardInfo) {
    return NavigationEventHistory_init_$Init$_0(currentInfo, backInfo, forwardInfo, objectCreate(protoOf(NavigationEventHistory)));
  }
  function NavigationEventHistory(mergedHistory, currentIndex) {
    this.f8p_1 = mergedHistory;
    this.g8p_1 = currentIndex;
    var tmp;
    if (this.f8p_1.r() && this.g8p_1 === -1) {
      tmp = true;
    } else {
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.f8p_1.r()) {
        var containsUpper = this.f8p_1.n1() - 1 | 0;
        var containsArg = this.g8p_1;
        tmp_0 = 0 <= containsArg ? containsArg <= containsUpper : false;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    // Inline function 'kotlin.require' call
    if (!tmp) {
      var message = "Invalid 'NavigationEventHistory' state:  'currentIndex' must be within the bounds of 'mergedHistory' (or -1 if empty)." + (" Received: currentIndex = '" + this.g8p_1 + "', bounds = '" + get_indices(this.f8p_1).toString() + "'.");
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  protoOf(NavigationEventHistory).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NavigationEventHistory))
      THROW_CCE();
    if (!(this.g8p_1 === other.g8p_1))
      return false;
    if (!equals(this.f8p_1, other.f8p_1))
      return false;
    return true;
  };
  protoOf(NavigationEventHistory).hashCode = function () {
    var result = this.g8p_1;
    result = imul(31, result) + hashCode(this.f8p_1) | 0;
    return result;
  };
  protoOf(NavigationEventHistory).toString = function () {
    return 'NavigationEventHistory(currentIndex=' + this.g8p_1 + ', mergedHistory=' + toString(this.f8p_1) + ')';
  };
  function NavigationEventInfo() {
  }
  function NavigationEventInput() {
    this.h8p_1 = null;
    this.i8p_1 = false;
    this.j8p_1 = false;
  }
  protoOf(NavigationEventInput).k8p = function (dispatcher) {
    this.l8p(dispatcher);
  };
  protoOf(NavigationEventInput).l8p = function (dispatcher) {
  };
  protoOf(NavigationEventInput).m8p = function (hasEnabledHandlers) {
    this.n8p(hasEnabledHandlers);
  };
  protoOf(NavigationEventInput).n8p = function (hasEnabledHandlers) {
  };
  protoOf(NavigationEventInput).o8p = function (history) {
    this.p8p(history);
  };
  protoOf(NavigationEventInput).p8p = function (history) {
  };
  protoOf(NavigationEventInput).q8p = function () {
    var tmp0 = this.h8p_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'This input is not added to any dispatcher.';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    var dispatcher = tmp$ret$0;
    if (!this.i8p_1) {
      dispatcher.b8o(this, -1, null);
    }
    dispatcher.d8o(this, -1);
    this.i8p_1 = false;
  };
  function resolveEnabledHandler($this, direction) {
    direction = direction === VOID ? 0 : direction;
    var tmp;
    switch (direction) {
      case 0:
        // Inline function 'androidx.navigationevent.NavigationEventProcessor.findHandler' call

        var tmp0 = $this.k8n_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            if (element.o8o() || element.q8o()) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }

        var tmp0_elvis_lhs = tmp$ret$1;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          var tmp0_0 = $this.l8n_1;
          var tmp$ret$3;
          $l$block_0: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s_0 = tmp0_0.t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              if (element_0.o8o() || element_0.q8o()) {
                tmp$ret$3 = element_0;
                break $l$block_0;
              }
            }
            tmp$ret$3 = null;
          }
          tmp_0 = tmp$ret$3;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }

        tmp = tmp_0;
        break;
      case -1:
        // Inline function 'androidx.navigationevent.NavigationEventProcessor.findHandler' call

        var tmp0_1 = $this.k8n_1;
        var tmp$ret$6;
        $l$block_1: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_1 = tmp0_1.t();
          while (_iterator__ex2g4s_1.u()) {
            var element_1 = _iterator__ex2g4s_1.v();
            if (element_1.o8o()) {
              tmp$ret$6 = element_1;
              break $l$block_1;
            }
          }
          tmp$ret$6 = null;
        }

        var tmp0_elvis_lhs_0 = tmp$ret$6;
        var tmp_1;
        if (tmp0_elvis_lhs_0 == null) {
          var tmp0_2 = $this.l8n_1;
          var tmp$ret$8;
          $l$block_2: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s_2 = tmp0_2.t();
            while (_iterator__ex2g4s_2.u()) {
              var element_2 = _iterator__ex2g4s_2.v();
              if (element_2.o8o()) {
                tmp$ret$8 = element_2;
                break $l$block_2;
              }
            }
            tmp$ret$8 = null;
          }
          tmp_1 = tmp$ret$8;
        } else {
          tmp_1 = tmp0_elvis_lhs_0;
        }

        tmp = tmp_1;
        break;
      case 1:
        // Inline function 'androidx.navigationevent.NavigationEventProcessor.findHandler' call

        var tmp0_3 = $this.k8n_1;
        var tmp$ret$11;
        $l$block_3: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_3 = tmp0_3.t();
          while (_iterator__ex2g4s_3.u()) {
            var element_3 = _iterator__ex2g4s_3.v();
            if (element_3.q8o()) {
              tmp$ret$11 = element_3;
              break $l$block_3;
            }
          }
          tmp$ret$11 = null;
        }

        var tmp0_elvis_lhs_1 = tmp$ret$11;
        var tmp_2;
        if (tmp0_elvis_lhs_1 == null) {
          var tmp0_4 = $this.l8n_1;
          var tmp$ret$13;
          $l$block_4: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s_4 = tmp0_4.t();
            while (_iterator__ex2g4s_4.u()) {
              var element_4 = _iterator__ex2g4s_4.v();
              if (element_4.q8o()) {
                tmp$ret$13 = element_4;
                break $l$block_4;
              }
            }
            tmp$ret$13 = null;
          }
          tmp_2 = tmp$ret$13;
        } else {
          tmp_2 = tmp0_elvis_lhs_1;
        }

        tmp = tmp_2;
        break;
      default:
        // Inline function 'kotlin.error' call

        var message = "Unsupported direction: '" + direction + "'.";
        throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function resolveCombinedBackInfo($this) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var combinedBackInfo = ArrayList_init_$Create$();
    var _iterator__ex2g4s = $this.k8n_1.t();
    while (_iterator__ex2g4s.u()) {
      var handler = _iterator__ex2g4s.v();
      var tmp;
      if (handler.o8o()) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp = !handler.g8o_1.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        combinedBackInfo.o1(handler.g8o_1);
      }
    }
    var _iterator__ex2g4s_0 = $this.l8n_1.t();
    while (_iterator__ex2g4s_0.u()) {
      var handler_0 = _iterator__ex2g4s_0.v();
      var tmp_0;
      if (handler_0.o8o()) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_0 = !handler_0.g8o_1.r();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        combinedBackInfo.o1(handler_0.g8o_1);
      }
    }
    return combinedBackInfo;
  }
  function NavigationEventProcessor() {
    this.g8n_1 = MutableStateFlow(Idle_getInstance());
    this.h8n_1 = asStateFlow(this.g8n_1);
    this.i8n_1 = MutableStateFlow(NavigationEventHistory_init_$Create$());
    this.j8n_1 = asStateFlow(this.i8n_1);
    this.k8n_1 = ArrayDeque_init_$Create$();
    this.l8n_1 = ArrayDeque_init_$Create$();
    this.m8n_1 = null;
    this.n8n_1 = 0;
    this.o8n_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.p8n_1 = LinkedHashSet_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_0.q8n_1 = LinkedHashSet_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_1.r8n_1 = LinkedHashSet_init_$Create$();
    this.s8n_1 = false;
    this.t8n_1 = false;
    this.u8n_1 = false;
  }
  protoOf(NavigationEventProcessor).n8o = function () {
    var tmp0 = this.k8n_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.o8o() || element.q8o()) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    var newOverlayEnabled = tmp$ret$0;
    var tmp0_0 = this.l8n_1;
    var tmp$ret$2;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0_0, Collection)) {
        tmp_0 = tmp0_0.r();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$2 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s_0 = tmp0_0.t();
      while (_iterator__ex2g4s_0.u()) {
        var element_0 = _iterator__ex2g4s_0.v();
        if (element_0.o8o() || element_0.q8o()) {
          tmp$ret$2 = true;
          break $l$block_2;
        }
      }
      tmp$ret$2 = false;
    }
    var newDefaultEnabled = tmp$ret$2;
    var newAnyEnabled = newOverlayEnabled || newDefaultEnabled;
    var overlayEnabledChanged = !(this.t8n_1 === newOverlayEnabled);
    var defaultEnabledChanged = !(this.s8n_1 === newDefaultEnabled);
    var anyEnabledChanged = !(this.u8n_1 === newAnyEnabled);
    if (overlayEnabledChanged) {
      var _iterator__ex2g4s_1 = this.r8n_1.t();
      while (_iterator__ex2g4s_1.u()) {
        var input = _iterator__ex2g4s_1.v();
        input.m8p(newOverlayEnabled);
      }
    }
    if (defaultEnabledChanged) {
      var _iterator__ex2g4s_2 = this.q8n_1.t();
      while (_iterator__ex2g4s_2.u()) {
        var input_0 = _iterator__ex2g4s_2.v();
        input_0.m8p(newDefaultEnabled);
      }
    }
    if (anyEnabledChanged) {
      var _iterator__ex2g4s_3 = this.p8n_1.t();
      while (_iterator__ex2g4s_3.u()) {
        var input_1 = _iterator__ex2g4s_3.v();
        input_1.m8p(newAnyEnabled);
      }
    }
    this.t8n_1 = newOverlayEnabled;
    this.s8n_1 = newDefaultEnabled;
    this.u8n_1 = newAnyEnabled;
    var tmp0_elvis_lhs = this.m8n_1;
    this.s8o(tmp0_elvis_lhs == null ? resolveEnabledHandler(this) : tmp0_elvis_lhs);
  };
  protoOf(NavigationEventProcessor).s8o = function (handler) {
    var tmp0_elvis_lhs = this.m8n_1;
    var activeHandler = tmp0_elvis_lhs == null ? resolveEnabledHandler(this) : tmp0_elvis_lhs;
    if (!equals(activeHandler, handler)) {
      return Unit_instance;
    }
    var tmp;
    if (activeHandler == null) {
      tmp = NavigationEventHistory_init_$Create$();
    } else {
      var tmp1_backInfo = resolveCombinedBackInfo(this);
      var tmp2_currentInfo = activeHandler.f8o_1;
      var tmp3_forwardInfo = activeHandler.h8o_1;
      tmp = NavigationEventHistory_init_$Create$_0(tmp2_currentInfo, tmp1_backInfo, tmp3_forwardInfo);
    }
    var newHistory = tmp;
    var oldHistory = this.i8n_1.u1();
    if (oldHistory.equals(newHistory)) {
      return Unit_instance;
    }
    this.i8n_1.s21(newHistory);
    var _iterator__ex2g4s = this.r8n_1.t();
    while (_iterator__ex2g4s.u()) {
      var input = _iterator__ex2g4s.v();
      input.o8p(newHistory);
    }
    var _iterator__ex2g4s_0 = this.q8n_1.t();
    while (_iterator__ex2g4s_0.u()) {
      var input_0 = _iterator__ex2g4s_0.v();
      input_0.o8p(newHistory);
    }
    var _iterator__ex2g4s_1 = this.p8n_1.t();
    while (_iterator__ex2g4s_1.u()) {
      var input_1 = _iterator__ex2g4s_1.v();
      input_1.o8p(newHistory);
    }
  };
  protoOf(NavigationEventProcessor).v8n = function (dispatcher, handler, priority) {
    // Inline function 'kotlin.require' call
    if (!(handler.l8o_1 == null)) {
      var message = "Handler '" + toString(handler) + "' is already registered with a dispatcher";
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    switch (priority) {
      case 0:
        this.k8n_1.zg(handler);
        break;
      case 1:
        this.l8n_1.zg(handler);
        break;
      default:
        throw IllegalArgumentException_init_$Create$('Unsupported priority value: ' + priority);
    }
    handler.l8o_1 = dispatcher;
    this.n8o();
  };
  protoOf(NavigationEventProcessor).y8n = function (handler) {
    if (equals(handler, this.m8n_1)) {
      var tmp0_subject = this.n8n_1;
      if (tmp0_subject === -1) {
        handler.x8o();
      } else if (tmp0_subject === 1) {
        handler.d8p();
      }
      this.m8n_1 = null;
      this.n8n_1 = 0;
      this.o8n_1 = null;
    }
    this.k8n_1.d3(handler);
    this.l8n_1.d3(handler);
    handler.l8o_1 = null;
    this.n8o();
  };
  protoOf(NavigationEventProcessor).a8o = function (dispatcher, input, priority) {
    // Inline function 'kotlin.require' call
    if (!(input.h8p_1 == null)) {
      var message = "Input '" + toString(input) + "' is already added to dispatcher " + toString_0(input.h8p_1) + '.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var inputs;
    switch (priority) {
      case 0:
        inputs = this.r8n_1;
        break;
      case 1:
        inputs = this.q8n_1;
        break;
      default:
        inputs = this.p8n_1;
        break;
    }
    // Inline function 'kotlin.collections.plusAssign' call
    inputs.j1(input);
    input.h8p_1 = dispatcher;
    input.k8p(dispatcher);
    input.o8p(this.j8n_1.u1());
    var hasEnabledHandlers;
    switch (priority) {
      case 0:
        hasEnabledHandlers = this.t8n_1;
        break;
      case 1:
        hasEnabledHandlers = this.s8n_1;
        break;
      default:
        hasEnabledHandlers = this.u8n_1;
        break;
    }
    input.m8p(hasEnabledHandlers);
  };
  protoOf(NavigationEventProcessor).c8o = function (input, direction, event) {
    if (!(this.n8n_1 === 0)) {
      return Unit_instance;
    }
    var handler = resolveEnabledHandler(this, direction);
    this.m8n_1 = handler;
    this.n8n_1 = direction;
    this.o8n_1 = input;
    if (!(event == null)) {
      switch (direction) {
        case -1:
          if (handler == null)
            null;
          else {
            handler.t8o(event);
          }

          break;
        case 1:
          if (handler == null)
            null;
          else {
            handler.z8o(event);
          }

          break;
        case 0:
          break;
      }
      this.g8n_1.s21(new InProgress(event, direction));
    }
  };
  protoOf(NavigationEventProcessor).e8o = function (input, direction, onBackCompletedFallback) {
    if (!equals(input, this.o8n_1) || !(direction === this.n8n_1)) {
      return Unit_instance;
    }
    var tmp0_elvis_lhs = this.m8n_1;
    var handler = tmp0_elvis_lhs == null ? resolveEnabledHandler(this, direction) : tmp0_elvis_lhs;
    this.m8n_1 = null;
    this.n8n_1 = 0;
    this.o8n_1 = null;
    switch (direction) {
      case -1:
        if (handler == null) {
          if (onBackCompletedFallback == null)
            null;
          else {
            onBackCompletedFallback.r8p();
          }
        } else {
          handler.v8o();
        }

        break;
      case 1:
        if (handler == null)
          null;
        else {
          handler.b8p();
        }

        break;
      case 0:
        break;
    }
    this.g8n_1.s21(Idle_getInstance());
  };
  function Idle() {
    Idle_instance = this;
    NavigationEventTransitionState.call(this);
  }
  protoOf(Idle).toString = function () {
    return 'Idle()';
  };
  var Idle_instance;
  function Idle_getInstance() {
    if (Idle_instance == null)
      new Idle();
    return Idle_instance;
  }
  function InProgress(latestEvent, direction) {
    NavigationEventTransitionState.call(this);
    this.s8p_1 = latestEvent;
    this.t8p_1 = direction;
  }
  protoOf(InProgress).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof InProgress))
      THROW_CCE();
    if (!(this.t8p_1 === other.t8p_1))
      return false;
    if (!this.s8p_1.equals(other.s8p_1))
      return false;
    return true;
  };
  protoOf(InProgress).hashCode = function () {
    var result = this.t8p_1;
    result = imul(31, result) + this.s8p_1.hashCode() | 0;
    return result;
  };
  protoOf(InProgress).toString = function () {
    return 'InProgress(latestEvent=' + this.s8p_1.toString() + ', direction=' + this.t8p_1 + ')';
  };
  function Companion_0() {
    this.u8p_1 = 0;
    this.v8p_1 = 1;
    this.w8p_1 = -1;
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function NavigationEventTransitionState() {
  }
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = NavigationEventHandler;
  _.$_$.b = NavigationEventInfo;
  _.$_$.c = NavigationEventInput;
  _.$_$.d = Idle;
  _.$_$.e = InProgress;
  _.$_$.f = Idle_getInstance;
  _.$_$.g = NavigationEventDispatcher_init_$Create$;
  _.$_$.h = NavigationEventHandler_init_$Init$;
  //endregion
  return _;
}));

//# sourceMappingURL=androidx-navigationevent-navigationevent.js.map
